<span>
  {{rangePresentation}}
</span>